import { UsersRound } from 'lucide-react';
import type { OperationsTravelGroup } from '@/shared/api';

/**
 * Reisegruppe im Tagesdetail: eine Buchung über mehrere Apartments (Gruppe, Familie). Wer an einer
 * Tür steht, soll wissen, dass die Nachbarwohnung zur selben Ankunft gehört.
 */
export function HeuteTravelGroupNote({
  group,
  propertyId,
}: {
  group: OperationsTravelGroup;
  propertyId: string;
}) {
  const others = group.apartments
    .filter((apartment) => apartment.propertyId !== propertyId)
    .map((apartment) => apartment.adminDisplayName);
  if (others.length === 0) return null;
  const who = group.mainBookerName ?? group.reference ?? 'eine Buchung';
  return (
    <p className="bg-paper rounded-control text-ink flex items-start gap-2 px-3 py-2.5 text-sm">
      <UsersRound size={16} className="mt-0.5 shrink-0" aria-hidden />
      <span>
        Reisegruppe {who}: gehört zusammen mit {others.join(', ')} ({group.guestCount}{' '}
        {group.guestCount === 1 ? 'Gast' : 'Gäste'}).
      </span>
    </p>
  );
}
